import type {
  ActiveFilter,
  FilterFieldDef,
  SearchableFilterOption,
} from "@/components/ui/filter-panel";
import type { UserResponse } from "@/lib/api/model/userResponse";

export type ProjectSelector = "all" | "my";

export const SELECTOR_TABS: { id: ProjectSelector; label: string }[] = [
  { id: "all", label: "All Projects" },
  { id: "my", label: "My Projects" },
];

export const BASE_PROJECT_FILTER_FIELDS: FilterFieldDef[] = [
  {
    key: "status",
    label: "Status",
    icon: "IconSettingsKnob",
    options: [
      { value: "active", label: "Active" },
      { value: "archived", label: "Archived" },
    ],
  },
  {
    key: "visibility",
    label: "Visibility",
    icon: "IconEyeOpen",
    options: [
      { value: "shared", label: "Shared" },
      { value: "private", label: "Private" },
    ],
  },
];

export function buildProjectFilterFields(
  members: UserResponse[],
): FilterFieldDef[] {
  const searchableOptions: SearchableFilterOption[] = members.map((m) => ({
    id: m.id,
    label: `${m.first_name} ${m.last_name}`.trim() || m.email,
    avatarUrl: m.avatar_url ?? null,
  }));
  return [
    ...BASE_PROJECT_FILTER_FIELDS,
    {
      key: "creator",
      label: "Creator",
      icon: "IconPeople",
      type: "searchable",
      options: [],
      searchableOptions,
      placeholder: "Select creator…",
    },
  ];
}

export function projectFiltersToQueryParams(
  filters: ActiveFilter[],
) {
  const params: Record<string, string | undefined> = {};
  for (const f of filters) {
    if (f.field === "status") {
      if (f.operator === "is") params.status = f.value;
      else if (f.operator === "is_not") params.status_not = f.value;
    }
    if (f.field === "visibility") {
      if (f.operator === "is") params.visibility = f.value;
      else if (f.operator === "is_not") params.visibility_not = f.value;
    }
    if (f.field === "creator") {
      if (f.operator === "is") params.creator_id = f.value;
      else if (f.operator === "is_not") params.creator_id_not = f.value;
    }
  }
  return params;
}
